"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var Modal_1 = __importDefault(require("./Modal"));
var Poll = /** @class */ (function (_super) {
    __extends(Poll, _super);
    function Poll() {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        _this = _super.call(this, constants_1.DATA_POLL_INTRO) || this;
        if (!_this.getElement())
            return _this;
        _this.buttonStart = _this.getChildElement("[".concat(constants_1.DATA_POLL_BUTTON_START, "]"));
        _this.modal = document.querySelector('.modal');
        _this.modalFeedback = document.querySelector("[".concat(constants_1.DATA_MODAL, "=\"feedback\"]"));
        _this.modalClose = (_a = _this.modalFeedback) === null || _a === void 0 ? void 0 : _a.querySelectorAll("[".concat(constants_1.DATA_MODAL_CLOSE, "]"));
        _this.modalFlag = document.querySelector("[".concat(constants_1.DATA_MODAL_FLAG, "]"));
        _this.hoverBox = document.querySelector("[".concat(constants_1.DATA_POLL_HOVER_OPEN, "]"));
        Poll.modalOpen = document.querySelector("[".concat(constants_1.DATA_MODAL_OPEN, "=\"feedback\"]"));
        _this.pollForm = document.querySelector("[".concat(constants_1.DATA_POLL_FORM, "]"));
        _this.pollAmount = (_b = _this.pollForm) === null || _b === void 0 ? void 0 : _b.querySelector("[".concat(constants_1.DATA_POLL_AMOUNT, "]"));
        _this.pollPages = (_c = _this.pollAmount) === null || _c === void 0 ? void 0 : _c.querySelectorAll("[".concat(constants_1.DATA_POLL_PAGE, "]"));
        _this.pollSuccess = (_d = _this.pollForm) === null || _d === void 0 ? void 0 : _d.querySelector("[".concat(constants_1.DATA_POLL_SUCCESS, "]"));
        _this.buttonsPrev = (_e = _this.pollForm) === null || _e === void 0 ? void 0 : _e.querySelectorAll("[".concat(constants_1.DATA_POLL_BUTTON_PREV, "]"));
        _this.buttonsNext = (_f = _this.pollForm) === null || _f === void 0 ? void 0 : _f.querySelectorAll("[".concat(constants_1.DATA_POLL_BUTTON_NEXT, "]"));
        (_g = _this.modalClose) === null || _g === void 0 ? void 0 : _g.forEach(function (close) { return close === null || close === void 0 ? void 0 : close.addEventListener('click', function () { return _this.closeFeedback(); }); });
        if (localStorage.getItem('poll')) {
            (_h = _this.modalFlag) === null || _h === void 0 ? void 0 : _h.classList.add('d-none');
            (_j = _this.hoverBox) === null || _j === void 0 ? void 0 : _j.classList.remove(constantsClasses_1.CLASS_ACTIVE);
        }
        else {
            (_k = _this.hoverBox) === null || _k === void 0 ? void 0 : _k.addEventListener('hover', function () {
                var _a, _b;
                if (!localStorage.getItem('poll')) {
                    if (localStorage.getItem('pollHoverBoxOpened')) {
                        (_a = _this.hoverBox) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
                        return;
                    }
                    (_b = _this.hoverBox) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
                    localStorage.setItem('pollHoverBoxOpened', 'true');
                    Modal_1.default.openModal(Poll.modalOpen);
                    if (_this.modal.classList.contains(constantsClasses_1.CLASS_ACTIVE)) {
                        _this.hoverBox.classList.remove(constantsClasses_1.CLASS_ACTIVE);
                    }
                }
                else {
                    _this.hoverBox.classList.remove(constantsClasses_1.CLASS_ACTIVE);
                }
            });
            document.addEventListener('click', function () {
                var _a, _b;
                if (!localStorage.getItem('poll') && !((_a = _this.modal) === null || _a === void 0 ? void 0 : _a.classList.contains(constantsClasses_1.CLASS_ACTIVE))) {
                    (_b = _this.hoverBox) === null || _b === void 0 ? void 0 : _b.classList.add(constantsClasses_1.CLASS_ACTIVE);
                }
            });
            (_l = _this.buttonStart) === null || _l === void 0 ? void 0 : _l.addEventListener('click', function () { return _this.startPoll(); });
        }
        _this.activityTime();
        return _this;
    }
    Poll.prototype.startPoll = function () {
        var _this = this;
        var _a, _b, _c;
        var amount = parseInt((_a = this.pollAmount) === null || _a === void 0 ? void 0 : _a.dataset.pollAmount);
        var last = amount - 1;
        if (amount > 0) {
            (_b = this.getElement()) === null || _b === void 0 ? void 0 : _b.classList.add('hidden');
            this.showPage(0);
            this.buttonsNext.forEach(function (button, index) {
                button.addEventListener('click', function () { return _this.nextPage(index); });
            });
            this.buttonsPrev.forEach(function (button, index) {
                button.addEventListener('click', function () { return _this.prevPage(index + 1); });
            });
        }
        (_c = this.pollForm) === null || _c === void 0 ? void 0 : _c.addEventListener('submit', function (e) {
            var _a, _b, _c;
            e.preventDefault();
            var actionUrl = (_a = _this.pollForm) === null || _a === void 0 ? void 0 : _a.getAttribute('action');
            var init = {
                method: 'POST',
                body: new FormData(_this.pollForm),
            };
            (_b = _this.pollPages[last]) === null || _b === void 0 ? void 0 : _b.classList.remove(constantsClasses_1.CLASS_ACTIVE);
            fetch(actionUrl, init)
                .then(function () {
                localStorage.setItem('poll', 'feedback');
            })
                .catch(function (error) { return console.log(error); });
            (_c = _this.pollSuccess) === null || _c === void 0 ? void 0 : _c.classList.add(constantsClasses_1.CLASS_ACTIVE);
        });
    };
    /**
     * Show next page
     * @param page
     * @private
     */
    Poll.prototype.nextPage = function (page) {
        var nextPage = page + 1;
        this.showPage(nextPage);
        this.hidePage(page);
    };
    /**
     * Show previous page
     * @param page
     * @private
     */
    Poll.prototype.prevPage = function (page) {
        var prevPage = page - 1;
        this.showPage(prevPage);
        this.hidePage(page);
    };
    Poll.prototype.showPage = function (page) {
        var _a;
        (_a = this.pollPages[page]) === null || _a === void 0 ? void 0 : _a.classList.add(constantsClasses_1.CLASS_ACTIVE);
    };
    Poll.prototype.hidePage = function (page) {
        var _a;
        (_a = this.pollPages[page]) === null || _a === void 0 ? void 0 : _a.classList.remove(constantsClasses_1.CLASS_ACTIVE);
    };
    Poll.prototype.closeFeedback = function () {
        this.setCookie('pollClosed', '1', 1);
    };
    Poll.prototype.setCookie = function (cName, cValue, exDays) {
        var date = new Date();
        date.setTime(date.getTime() + (exDays * 24 * 60 * 60 * 1000));
        var expires = "expires=".concat(date.toUTCString());
        document.cookie = "".concat(cName, "=").concat(cValue, ";").concat(expires, ";path=/");
    };
    Poll.prototype.getCookie = function (cName) {
        var name = "".concat(cName, "=");
        var ca = document.cookie.split(';');
        ca.forEach(function (c) {
            var d = c;
            while (d.charAt(0) == ' ') {
                d = d.substring(1);
            }
            if (d.indexOf(name) == 0) {
                return d.substring(name.length, d.length);
            }
        });
        return '';
    };
    Poll.prototype.openModal = function () {
        if (!localStorage.getItem('poll')) {
            Modal_1.default.openModal(Poll.modalOpen);
        }
    };
    Poll.prototype.resetTimer = function () {
        clearTimeout(this.time);
        this.time = setTimeout(this.openModal, 120000);
    };
    Poll.prototype.activityTime = function () {
        var _this = this;
        var pollParticipated = this.getCookie('pollParticipate_1');
        var pollClosed = this.getCookie('pollClosed');
        if (!pollParticipated && !pollClosed) {
            window.addEventListener('load', function () { return _this.resetTimer(); });
            this.resetTimer();
        }
    };
    return Poll;
}(AbstractComponent_1.default));
exports.default = Poll;
